/** @typedef {import("../../api/types").ServiceItem} ServiceItem */
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import {Alert, Button, Card, CardBody, Container, Spinner} from "reactstrap";
import Field from "../../shared/components/Field";
import ServiceItemStatusBadge from "./components/ServiceItemStatusBadge";
import {formatMoney} from "../../shared/utils/format";
import ListLink from "../../shared/components/ListLink";
import IconLabel from "../../shared/components/IconLabel";
import {PencilIcon} from "../../shared/components/icons";

const ITEMS_URL = "/os/api/service_items/";

const ServiceItemDetail = () => {
    const {id} = useParams();
    const [item, setItem] = useState(/** @type {ServiceItem|null} */ (null));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError(null);
        setItem(null);

        axios
            .get(`${ITEMS_URL}${encodeURIComponent(id)}/`, {signal: controller.signal})
            .then(({data}) => setItem(data))
            .catch((err) => {
                if (axios.isCancel(err)) return;
                setError(
                    err.response?.status === 404 ? "Serviço não encontrado." : "Não foi possível carregar o serviço."
                );
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [id]);

    return (
        <Container className="mt-4 mb-5">
            <ListLink basePath="/service-items">&larr; Serviços</ListLink>
            {loading && (
                <div className="text-center mt-4">
                    <Spinner />
                </div>
            )}
            {error && (
                <Alert color="danger" className="mt-3">
                    {error}
                </Alert>
            )}
            {item && (
                <>
                    <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                        <h3 className="mb-0">{item.name}</h3>
                        <Button color="primary" outline tag={Link} to={`/service-items/${id}/edit`}>
                            <IconLabel icon={<PencilIcon size={16} />}>Editar</IconLabel>
                        </Button>
                    </div>
                    <Card>
                        <CardBody>
                            <Field label="Descrição" value={item.description} preserveLineBreaks />
                            <Field label="Valor base" value={item.base_value}>
                                {formatMoney(item.base_value, item.currency)}
                            </Field>
                            <Field label="Custo" value={item.cost}>
                                {formatMoney(item.cost, item.currency)}
                            </Field>
                            <Field label="Situação" value={item.status}>
                                <ServiceItemStatusBadge status={item.status} />
                            </Field>
                        </CardBody>
                    </Card>
                </>
            )}
        </Container>
    );
};

export default ServiceItemDetail;
